@if (activated) {
  @for (list of listViewData; track trackByListSpec($index, list)) {
    @if (list.isVisible) {
      <lm-list
        #LMListComponent
        [listUrlInfo]="list.listUrlInfo"
        [listSpec]="list.listSpec"
        [fromDataView]="fromDataView"
        [listText]="list.panelText"
        [specialActions]="list.specialActions"
        [isInOverlay]="isInOverlay"
        (listDisplayed)="onListDisplayed($event)"
        (sendContextMessageEvent)="onSendContextMessageEvent($event)"
        (contentModified)="onContentModified($event)"
        (specialActionToolbarButtonEvent)="onSpecialActionToolbarButtonEvent($event)"
        (listTransactionEvent)="onPanelTransactionEvent($event)"
        (drillAroundEvent)="onDrillAroundEvent($event)"
      ></lm-list>
    }
  }
}
